<template>
  <v-container>
    <v-row no-gutters justify="center" align="center">
      <v-slide-x-transition hide-on-leave>
        <router-view></router-view>
      </v-slide-x-transition>
    </v-row>
  </v-container>
</template>

<script>
import authutils from '@/mixins/authutils'

export default {
  name: 'LoginView',
  mixins: [authutils],
  methods: {
    mounted () {
      this.$store.dispatch('auth/tryRestoreLogin').then(result => {
        if (result) {
          this.redirectAfterLogin()
        }
      })
    }
  }
}
</script>
